import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductRepository from "src/repository/ProductRepository";

export const getDocumentList = createAsyncThunk('home_getDocumentList', async (params) => {
    let res = await new ProductRepository().getDocumentList(params)
    let result = {}
    result.data = res.data;
    return result
});

const initialState = {
    allTabsCount: {
        productListingCount: 0,
        npiCount: 0,
        allContentCount: 0,
        articleCount: 0,
        siteCount: 0,
        eventCount: 0,
        videoCount: 0,
        docCount: 0,

    },
    documentContent: {
        list: {},
        facets: {},
        count: 0,
    },
    documentContentAutosuggest: {
        list: {},
        facets: {},
        count: 0,
    },
    tabsData: {}
};

const slice = createSlice({
    name: "HomePageContent",
    initialState: initialState,
    reducers: {
        getIndividualTabsCount: {
            reducer: (state, action) => {
                state.allTabsCount = { ...state.allTabsCount, ...action.payload }
            },
        },
    },
    extraReducers: {
        [getDocumentList.fulfilled]: (state, { payload }) => {
            state.documentContent.list = payload.data.documentList;
            state.documentContent.facets = payload.data.facets;
            state.documentContent.count = payload.data.count;
        }

    },
});

export let { getIndividualTabsCount } = slice.actions;

export default slice.reducer;